import uiI18n from "../i18n";
import { useTranslation as useUiTranslation } from "react-i18next";
import React from "react";
  import { variables } from '../Variables.jsx';
import { useTranslation } from "react-i18next";
 import Moment from "react-moment"
 import Slider from "react-slick"
import { MdLocationOn } from "react-icons/md";
import { Link } from 'react-router-dom';
// moment.locale('fr');
// Custom arrow components
function NextArrow(props) {
  useUiTranslation();
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", right: "10px", zIndex: 1 }}
      onClick={onClick}
    >
      ➡️
    </div>
  );
}

function PrevArrow(props) {
  useUiTranslation();
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", left: "10px", zIndex: 1 }}
      onClick={onClick}
    >
      ⬅️
    </div>
  );
}

export default function ListPartyRooms({ listing, onEdit, onDelete }) {
  const PhotoPath = variables.PHOTO_URL;
  const { t } = useTranslation();
  const images = listing.urlImages ? listing.urlImages.split(',').map(image => PhotoPath + image) : [];

  const settings = {
    dots: images.length > 1,
    infinite: images.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: images.length > 1 ? <NextArrow /> : null,
    prevArrow: images.length > 1 ? <PrevArrow /> : null
  };

  return (
    <div key={listing.id} className="bg-white rounded-lg shadow-lg overflow-hidden relative m-2">
      <Link target="_blank" to={`/DetailsVacation/${listing.id}`} className="w-full">
        <Slider {...settings}>
          {images.length > 0 ? (
            images.map((image, index) => (
              <div key={index}>
                <img src={image} alt={listing.title} className="w-full h-48 object-cover" />
              </div>
            ))
          ) : (
            <div className="text-center py-10">{uiI18n.t("ui.no_images_available")}</div>
          )}
        </Slider>
        <Moment
          className="absolute top-2 start-2 bg-gray-600 text-white uppercase text-xs font-semibold rounded-md px-2 py-1 shadow-lg"
          fromNow
        >
          {listing.dateAjout}
        </Moment>
        <div className="p-4">
          <h3 className="text-lg font-bold">{listing.title}</h3>
          <p className="text-lg semibold m-2 ">{listing.category} : {listing.ville} </p>
          <div className="flex items-center space-x-2 mb-2">
            <MdLocationOn className="h-5 w-5 text-green-600" />
            <p className="font-semibold text-sm truncate">
              {[listing.adresse, listing.delegation, listing.ville].join(' ')}
            </p>
          </div>
          <p className="text-sm m-1 text-gray-900">{listing.libelle}</p>
          <p className="text-sm m-1 text-gray-900">{uiI18n.t("ui.host")} {listing.name}</p>
          <div className="mt-2">
            {listing.prixReduit ? (
              <div className="flex items-center">     
                <span className="text-gray-900 line-through ">{listing.prix} dt</span>
                <span className="font-semibold ms-2">{listing.prixReduit} {uiI18n.t("ui.tnd_night")}</span>
              </div>
            ) : (
              <span className="font-semibold">{listing.prix} {uiI18n.t("ui.tnd_night")}</span>
            )}
          </div>
          {/* <div className="mt-2 flex items-center">
            <span className="text-green-500 text-sm">⭐ 4 (18)</span>
          </div> */}
        </div>
      </Link>
    </div>
  );
  
  
}
